import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type EnvState = {
  id: string | null;
};

const initialState: EnvState = {
  id: null,
};

const envSlice = createSlice({
  name: 'env',
  initialState,
  reducers: {
    updateEnvironmentId(state, action: PayloadAction<string>) {
      state.id = action.payload;
    },
  },
});

export const env = envSlice.reducer;

export const { updateEnvironmentId } = envSlice.actions;
